'use client';

import BrailleSpinner from './BrailleSpinner';

export default function FullPageSpinner() {
  return (
    <div
      className="min-h-screen"
      style={{
        backgroundColor: '#1a1a1a',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <BrailleSpinner label="" />
    </div>
  );
}
